import socket from '../Core/socketConnect.js';
import CounterService from './Timer/counterService.js';

const clientUserGid = data_handler.clientUserGid,
	linkFirstChapter = data_handler.linkFirstChapter;

const DOMElements = {
	startGameButtonAdmin: '#start-button-admin-button',
	startGameButtonMembers: '#start-button-members-button',
	startGameButtonText: '#start-button-members-text',
};

const startGameButtonAdmin = document.querySelector(
		DOMElements.startGameButtonAdmin
	),
	startGameButtonMembers = document.querySelector(
		DOMElements.startGameButtonMembers
	),
	startGameButtonText = document.querySelector(
		DOMElements.startGameButtonText
	);

const socketEmitStartGame = () => {
	socket.emit('game-start', {
		gid: clientUserGid,
	});
};

const startGameForMembers = () => {
	if (startGameButtonMembers) {
		startGameButtonMembers.setAttribute(
			'onclick',
			"window.location.href='" + linkFirstChapter + "';"
		);
	}
	if (startGameButtonText) {
		startGameButtonText.innerHTML = 'Go!';
	}
};

const pageRedirect = () => {
	window.location.replace(linkFirstChapter);
};

const startGameRestCall = async () => {
	fetch('/wp-json/bluebird-games/v1/startgame/', {
		method: 'POST',
		body: 'group_id=' + clientUserGid,
		headers: {
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
			'Access-Control-Allow-Headers': '*',
			'Content-type': 'application/x-www-form-urlencoded',
		},
	})
		.then(function (response) {
			if (response.ok) {
				startGameForMembers();
				socketEmitStartGame();
				return response.json();
			}
			return Promise.reject(response);
		})
		.catch(function (error) {
			console.warn('Something went wrong.', error);
		});
};

const StartButtonAction = {
	bindEvents: () => {
		if (startGameButtonAdmin) {
			startGameButtonAdmin.addEventListener('click', startGameRestCall);
		}
	},
	startButtonSocketListener: () => {
		socket.on('game-start', function (data) {
			if (data.data.gid === clientUserGid) {
				CounterService.grouptimerfunction();
				pageRedirect();
			}
		});
	},
};

export default StartButtonAction;
